module.exports = __webpack_public_path__ + "img/thumbnail_StripedSkunk_m_albino.76e09e10.png";